module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BOOKS BY SALLY HELGESEN")])])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("The Female Advantage: Women’s Ways of Leadership")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('em', [_vm._v("The Web of Inclusion: A New Architecture for Building Great"), _c('br'), _vm._v("Organizations")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('em', [_vm._v("Thriving in 24/7: Six Strategies for Taming the New World"), _c('br'), _vm._v("of Work")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('em', [_vm._v("Everyday Revolutionaries: Working Women and the"), _c('br'), _vm._v("Transformation of American Life")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('em', [_vm._v("Wildcatters: A Story of Texans, Oil, and Money")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 63
// module chunks = 0